<p-toast></p-toast>
<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  [modal]="true"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar Orden de Compra"
  [style]="{ width: '90%', height: '100%' }"
  (onHide)="onClose()"
>
  <div class="card">
    <div class="flex justify-content-center">
      <div class="flex align-items-center justify-content-center">
        <div class="p-fluid p-formgrid grid">
          <form [formGroup]="fg">
            <div class="col-12 md:col-11 grid">
              <div class="col-12 md:col-11">
                <span class="block text-3xl font-medium text-900 mt-2"
                  >Editar Orden de Compra
                </span>
              </div>
              <div class="col-12 md:col-1 mt-2">
                <pg-cart-purchase-order
                  [groupItems]="newItems"
                ></pg-cart-purchase-order>
              </div>
              <div class="col-8">
                <p-message
                  severity="info"
                  text="Registre, elimine o modifique los productos, asegurese de ingresar los datos correctamente."
                  styleClass="p-mr-2 "
                ></p-message>
              </div>

              <div class="field col-12 md:col-12 mb-4">
                <p-fieldset legend="Detalles" [toggleable]="false">
                  <div class="grid">
                    <div class="field col-12 md:col-6">
                      <label>Fecha de Entrega</label>
                      <input
                        pInputText
                        formControlName="delivery_at"
                        type="date"
                      />
                    </div>

                    <div class="field col-12 md:col-6">
                      <label>Documento</label>
                      <input
                        pInputText
                        formControlName="numberDocument"
                        type="text"
                      />
                      <div
                        class="p-invalid"
                        *ngIf="
                          fg.get('numberDocument').invalid &&
                          (fg.get('numberDocument').dirty ||
                            fg.get('numberDocument').touched)
                        "
                      >
                        <div *ngIf="fg.get('numberDocument').errors?.required">
                          <small class="p-error">No puede quedar vacío.</small>
                        </div>
                      </div>
                    </div>
                    <div class="field col-12 md:col-6">
                      <label>Términos de Pago</label>
                      <p-dropdown
                        [style]="{ width: '100%', overflow: 'visible' }"
                        formControlName="paymentTerms"
                        class="w-full"
                        placeholder="Seleccionar"
                        [options]="PAYMENT_TERMS_NAMES_FOR_DROPDOWN"
                        optionLabel="label"
                        optionValue="value"
                      ></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-6">
                      <label>Impuesto</label>
                      <p-dropdown
                        [style]="{ width: '100%', overflow: 'visible' }"
                        formControlName="tax"
                        class="w-full"
                        placeholder="Seleccionar"
                        [options]="TAX_NAMES_FOR_DROPDOWN"
                        optionLabel="label"
                        optionValue="value"
                      ></p-dropdown>
                    </div>
                  </div>
                </p-fieldset>
              </div>
              <div class="field col-12 md:col-12 mb-4">
                <pg-provider-details
                  (onSelect)="providerSelected.onSelect($event)"
                  [legend]="providerSelected.legend"
                  [data]="data"
                ></pg-provider-details>
              </div>
              <div class="col-12">
                <pg-products-provider
                  [providerId]="providerSelected.getId()"
                ></pg-products-provider>
              </div>
            </div>
            <div class="flex justify-content-center card-container mt-3">
              <button
                (click)="onSubmit()"
                pButton
                pRipple
                class="p-button-sg p-button-success"
                pTooltip="Agregar Stock"
                tooltipPosition="bottom"
                style="width: '15%'"
                styleClass="text-center"
              >
                CONFIRMAR OPERACIÓN
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
